export const dashboardPalette = {
  pageBg: "#20367f",
  pageBgAlt: "#2b4eb0",
  panelBg: "#f7f9ff",
  panelSoft: "#eef3ff",
  panelBorder: "#6e83cb",
  headerBlue: "#2f2b74",
  sectionBlue: "#afbee9",
  accentYellow: "#f7c50b",
  accentYellowDark: "#d39e00",
  teal: "#4fc286",
  track: "#bec4d3",
  sidebarBg: "#eef2ff",
  sidebarInk: "#20336f",
  textDark: "#28324f",
  white: "#ffffff",
  mascotBg: "#56c5e8",
  heroGlow: "rgba(124, 92, 252, 0.26)",
  heroGlowAlt: "rgba(79, 194, 134, 0.2)",
};

export const appThemeTokens = {
  colorPrimary: dashboardPalette.headerBlue,
  colorInfo: dashboardPalette.headerBlue,
  colorSuccess: dashboardPalette.teal,
  colorWarning: dashboardPalette.accentYellow,
  colorBgLayout: dashboardPalette.pageBg,
  colorBgContainer: dashboardPalette.panelBg,
  colorBorder: dashboardPalette.panelBorder,
  borderRadius: 18,
  fontFamily:
    "Poppins, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
};

export default dashboardPalette;